<div class="modal-overlay" tabindex="-1" role="dialog" *ngIf="errorData">

  <div class="modal-dialog">

    <div class="modal-header">
      <i class="fa fa-exclamation-circle fa-2x"></i>
      <span>{{errorData.ExceptionType == 'Warning' ? 'Melding' : 'Fout'}}</span>
      <button aria-label="Sluit melding" (click)="cancel()" class="btn-icon fa fa-times fa-2x"></button>      
    </div>

    <ul class="modal-content">
      <li *ngFor="let item of errorData.Errors">
        {{item.FriendlyMessage || item.Message}}
      </li>
    </ul>

  </div>

</div>